import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Landing } from './pages/Landing';
import { ThankYou } from './pages/ThankYou';
import { analytics, GTM_CONTAINER_ID } from './analytics';

/**
 * Injects the Google Tag Manager <noscript> iframe (the "body code") once, so
 * tracking still works when JavaScript is disabled. The gtm.js "head code" is
 * loaded by the GTM analytics plugin in ./analytics.
 */
function useGtmNoscript() {
  useEffect(() => {
    const id = 'gtm-noscript';
    if (document.getElementById(id)) return;
    const noscript = document.createElement('noscript');
    noscript.id = id;
    const iframe = document.createElement('iframe');
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${GTM_CONTAINER_ID}`;
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';
    noscript.appendChild(iframe);
    document.body.insertBefore(noscript, document.body.firstChild);
  }, []);
}

/** Tracks a GTM page view on every route change. */
function usePageViews() {
  const location = useLocation();
  useEffect(() => {
    analytics.page();
  }, [location.pathname]);
}
function AnalyticsRoutes() {
  useGtmNoscript();
  usePageViews();
  return <Routes data-id="element-0" data-mp="5otf64sd496">
      <Route path="/" element={<Landing data-id="element-2" data-mp="4n53zyrel9i" />} data-id="element-1" data-mp="6hpnd64cbd2" />
      <Route path="/thank-you" element={<ThankYou data-id="element-4" data-mp="2zl3cxocsjc6w" />} data-id="element-3" data-mp="56lvdcob3ly" />
    </Routes>;
}
export function App() {
  return <BrowserRouter data-id="element-5" data-mp="2zn6bwxvx8fnr">
      <AnalyticsRoutes data-id="element-6" data-mp="33mowfsjtyoq2" />
    </BrowserRouter>;
}